<template>
    <ListPage :query="query" :total="total" v-loading="loading" :data="tableData" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" @search="handleSearch" @reset="resetQuery">
        <template slot="filters">
            <el-form-item label="关键词" prop="keywords">
                <el-input v-model="query.keywords" placeholder="请输入消息关键词搜索" clearable
                    @keyup.enter.native="handleSearch" />
            </el-form-item>
            <el-form-item label="发布日期" prop="date">
                <el-date-picker v-model="query.date" value-format="yyyy-MM-dd" type="daterange" range-separator="~"
                    start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
        </template>
        <template slot="btns" v-if="permission('/message/add')">
            <el-button size="mini" icon="el-icon-plus" type="primary" @click="handleAdd">
                新增消息
            </el-button>
        </template>
        <template slot="columns">
            <el-table-column type="index" label="序号" width="100" align="center" />
            <el-table-column label="发布时间" align="center" prop="createTime"></el-table-column>
            <el-table-column label="消息标题" align="center" prop="title"></el-table-column>
            <el-table-column label="消息标题（英文）" align="center" prop="enTitle"></el-table-column>
            <el-table-column label="操作" align="center" width="140" v-if="permission('/message/delete')">
                <template slot-scope="{ row }">
                    <el-link :underline="false" type="danger" @click="handleDelete(row)">
                        删除
                    </el-link>
                </template>
            </el-table-column>
        </template>
    </ListPage>
</template>

<script>
import { page, del } from "@/api/message/list";
import listMixin from '@/mixins/list';
export default {
    data() {
        return {
            // 查询参数
            query: {
                keywords: "",
                date: [],
                pageNo: 1,
                pageSize: 10
            },
        };
    },
    mixins: [listMixin],
    mounted() {

    },
    methods: {
        search() {
            this.loading = true;
            const params = {
                ...this.query,
                startTime: this.query.date && this.query.date[0] ? this.query.date[0] + " 00:00:00" : "",
                endTime: this.query.date && this.query.date[1] ? this.query.date[1] + " 23:59:59" : ""
            };
            delete params.date;
            page(params).then(({ code, result, message }) => {
                if (code == 200) {
                    this.tableData = result.records || [];
                    this.total = result.total || 0;
                } else {
                    this.$message.error(message);
                }
                this.loading = false;
            });
        },
        handleAdd() {
            this.$router.push({ path: "/message/form" });
        },
        handleDelete(row) {
            this.$confirm("确定删除该消息吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                del({ id: row.id }).then(({ code, message }) => {
                    if (code == 200) {
                        this.$message.success("删除成功");
                        this.search();
                    } else {
                        this.$message.error(message);
                    }
                });
            });
        }
    },
};
</script>